import { TicketsSearch } from "./tickets-search"
import { TicketList } from "./ticket-list"
import { PageHeader } from "@/widgets/page-header"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { fetchAircraft, fetchAirlines, fetchAirports, fetchCountries, selectAircraftFirstLoad, selectAirlinesFirstLoad, selectAirportsFirstLoad, selectCountriesFirstLoad } from "@/entities/aviabooking-reference"
import { useEffect, useRef } from "react"
import { useState } from "react"
import { useSavedFlights } from "../lib/use-saved-flights"
import { SavedFlights } from "./saved-flights"

export const AviabookingPage = () => {
    const [tab, setTab] = useState<"search" | "saved">("search")
    const saved = useSavedFlights()
    const isFirstRender = useRef(true)
    const dispatch = useAppDispatch()
    const airportsFirstLoad = useAppSelector(selectAirportsFirstLoad)
    const aircraftFirstLoad = useAppSelector(selectAircraftFirstLoad)
    const countriesFirstLoad = useAppSelector(selectCountriesFirstLoad)
    const airlinesFirstLoad = useAppSelector(selectAirlinesFirstLoad)

    useEffect(() => {
        if (aircraftFirstLoad) {
            dispatch(fetchAircraft())
        }
        if (airportsFirstLoad) {
            dispatch(fetchAirports())
        }
        if (airlinesFirstLoad) {
            dispatch(fetchAirlines())
        }
        if (countriesFirstLoad) {
            dispatch(fetchCountries())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Авиабилеты" />
            <div className="flexbox">
                <div className="flex gap-3 mb-5" role="group" aria-label="Раздел авиабилетов">
                    <button type="button" aria-pressed={tab === "search"} onClick={() => setTab("search")} className="rounded-xl bg-white p-3">Поиск рейсов</button>
                    <button type="button" aria-pressed={tab === "saved"} onClick={() => setTab("saved")} className="rounded-xl bg-white p-3">Сохранённые ({saved.total})</button>
                </div>
                {tab === "search" && <TicketsSearch />}
                <div className="flex gap-6">
                    {/* <div className="shrink-0">
                        <TicketFilters />
                    </div> */}
                    <div className="w-full">
                        {tab === "search" ? <>
                            {saved.actionError && <p role="alert" className="text-red-700 text-sm">{saved.actionError}</p>}
                            {saved.error && <p role="alert">{saved.error} <button type="button" onClick={() => void saved.load(saved.failedOffset ?? 0)} className="underline">Повторить</button></p>}
                            <TicketList saved={saved} />
                        </> : <SavedFlights {...saved} onLoad={saved.load} onRemove={saved.remove} />}
                    </div>
                </div>
            </div>
        </div>
    )
}